// extracted by mini-css-extract-plugin
export default {"root":"ConnectionIndicator-root-b4a7","online":"ConnectionIndicator-online-f1d8"};